<template>
  <div>
    <v-row justify="center">
      <!--Locations-->

 

      <!--Campaigns-->


      <!--Settings-->
      <v-dialog v-model="alertModalSettings.active" max-width="390">
        <v-card>
          <v-card-title class="headline">Hubo un problema de conexión</v-card-title>

          <v-card-text>Inténtalo de nuevo volviendo a cargar la página</v-card-text>

          <v-card-text>
            <strong>{{alertModalSettings.err.msg}}</strong>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn color="green darken-1" text @click="alertModalSettings.active = false">Cerrar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "CatchAlert",
  computed: {
    ...mapState("settings", ["alertModalSettings"]),
  },
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/CatchAlert.vue